export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.table    = json.table
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries


      this.gmx_tableCoordinates('x', this.columns, 0)
      this.table.width = this.columns[this.columns.length-1].ex + (this.table.padding*2)
      this.table.height = (this.table.lineheight * (this.table.noItem+1)) + (this.table.padding * 2) - (this.table.lineheight/2)

    },

  }
}